export default __webpack_public_path__ + "static/media/Delete.f30d0907.svg";